import React from "react";
import "./index.css";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";

const MisConfirmPage = (props) => {
  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "long",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  const selectedColumns = props?.columnsData.filter((col) => col.selected);

  return (
    <>
      <div
        className={`Mis_report_Main_div pb-padding-md px-padding-md Qmd:px-padding-base gap-x-gap-md`}
      >
        <div className="Mis_report_first">
          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                Field
              </p>
              <div className="flex flex-col justify-between gap-y-gap-xs">
                <p className="font-normal text-font-md text-text-primary ">
                  {props?.selectedOption}
                </p>
                <p className="font-normal text-font-xs  text-text-secondary">
                  Field selected
                </p>
              </div>
            </div>
          </div>
          {props?.startDate && props?.endDate && (
            <div className="Mis_report_SelectAcc_div_confirm">
              <div className="flex flex-col gap-y-gap-md relative">
                <p className="font-semibold text-font-md text-text-primary">
                  Date Range
                </p>
                <div className="flex flex-col justify-between gap-y-gap-xs">
                  <p className="font-normal text-font-md text-text-primary">
                    {`${formateDate(props?.startDate)} - ${formateDate(
                      props?.endDate,
                    )}`}
                  </p>
                  <p className="font-normal text-font-xs  text-text-secondary">
                    Selected range
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                Columns
              </p>
              {selectedColumns.map((col, index) => (
                <div key={col.columnId}>
                  <p className="font-normal text-font-md text-text-primary">
                    {col.columnName}
                  </p>

                  {index !== selectedColumns.length - 1 && (
                    <div className="border-t border-primary-bg mt-margin-sm"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="Mis_report_Additional_div">
          <div className="Mis_report_first">
            {props?.selectedValues?.dropdown1 !== "" &&
            props?.selectedValues?.dropdown2 !== "" ? (
              <div className="Mis_report_SelectAcc_div_confirm">
                <div className="flex flex-col gap-y-gap-md relative">
                  <p className="font-semibold text-font-md text-text-primary">
                    Sort By{" "}
                    <span className=" font-semibold text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <div className="flex flex-col justify-between gap-y-gap-sm">
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {props?.selectedValues?.dropdown1}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        Column
                      </p>
                    </div>
                    <div className=" border-t-border border-primary-bg"></div>
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {props?.selectedValues?.dropdown2}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        Select field to sort the report by
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{ backgroundColor: "var(--primary-card)" }}
                className="Mis_report_filter_name relative"
              >
                <>
                  <div className="w-full flex flex-col gap-gap-md h-fit">
                    <p className="font-semibold text-font-md  text-text-primary">
                      Sort By <span className="font-semibold">(Optional)</span>
                    </p>
                    <p className="text-font-md h-fit text-text-secondary">
                      No sorting selected.
                    </p>
                  </div>
                </>
              </div>
            )}
            {props?.filterMapping?.length > 0 ? (
              <>
                {props?.filterMapping.map((col, index) => (
                  <div
                    className="Mis_report_SelectAcc_div_confirm"
                    key={col?.columnId}
                  >
                    <div className="flex flex-col gap-y-gap-md relative">
                      <p className="font-semibold text-font-md text-text-primary tracking- mb-margin-xs">
                        Filter By{" "}
                        <span className="font-semibold text-text-primary">
                          (Optional)
                        </span>
                      </p>
                      <div className="flex flex-col justify-between gap-y-gap-sm">
                        <div className="flex flex-col justify-between gap-y-gap-xs">
                          <p className="font-normal text-font-md text-text-primary ">
                            {col?.column_name}
                          </p>
                          <p className="font-normal text-font-xs  text-text-secondary">
                            Column
                          </p>
                        </div>
                        <div className=" border-t-border border-primary-bg"></div>
                        <div className="flex flex-col justify-between gap-y-gap-xs">
                          <p className="font-normal text-font-md text-text-primary ">
                            {col?.criteria_name}
                          </p>
                          <p className="font-normal text-font-xs  text-text-secondary">
                            Criteria
                          </p>
                        </div>
                        <div className=" border-t-border border-primary-bg"></div>
                        <div className="flex flex-col justify-between gap-y-gap-xs">
                          <p className="font-normal text-font-md text-text-primary capitalize">
                            {col?.column_name == "Amount" ? (
                              <FormatAmount price={col.input_value} />
                            ) : typeof col?.input_value === "boolean" ? (
                              col.input_value ? (
                                "Yes"
                              ) : (
                                "No"
                              )
                            ) : typeof col?.input_value === "string" ||
                              typeof col?.input_value === "number" ? (
                              col.input_value
                            ) : (
                              ""
                            )}
                          </p>
                          <p className="font-normal text-font-xs text-text-secondary">
                            {props?.selectedOption === "User"
                              ? "Detail"
                              : col?.column_name}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div
                style={{ backgroundColor: "var(--primary-card)" }}
                className="Mis_report_filter_name relative"
              >
                <>
                  <div className="w-full flex flex-col gap-gap-md h-fit">
                    <p className="font-semibold text-font-md  text-text-primary">
                      Filter By{" "}
                      <span className="font-semibold ">(Optional)</span>
                    </p>
                    <p className="text-font-md h-fit text-text-secondary ">
                      No filter added.
                    </p>
                  </div>
                </>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MisConfirmPage;
